import { render, staticRenderFns } from "./truncate_text.vue?vue&type=template&id=af92423e"
import script from "./truncate_text.vue?vue&type=script&lang=js"
export * from "./truncate_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports